import importer from "common/importer";

const login = importer("Sagas/Users/login/main");
const loginSuccess = importer("Sagas/Users/login/success");
const loginFailure = importer("Sagas/Users/login/failure");

const loginAuth = importer("Sagas/Users/loginAuth/main");
const loginAuthSuccess = importer("Sagas/Users/loginAuth/success");
const loginAuthFailure = importer("Sagas/Users/loginAuth/failure");

const loginTokenExchange = importer("Sagas/Users/loginTokenExchange/main");
const loginTokenExchangeSuccess = importer(
  "Sagas/Users/loginTokenExchange/success"
);
const loginTokenExchangeFailure = importer(
  "Sagas/Users/loginTokenExchange/failure"
);
//
const loginHeroku = importer("Sagas/Users/loginHeroku/main");
const loginHerokuSuccess = importer("Sagas/Users/loginHeroku/success");
const loginHerokuFailure = importer("Sagas/Users/loginHeroku/failure");

const loginWithToken = importer("Sagas/Users/loginWithToken/main");
const loginWithTokenSuccess = importer("Sagas/Users/loginWithToken/success");
const loginWithTokenFailure = importer("Sagas/Users/loginWithToken/failure");

const loginWithProxyPdn = importer("Sagas/Users/loginWithProxyPdn/main");
const loginWithProxyPdnSuccess = importer(
  "Sagas/Users/loginWithProxyPdn/success"
);
const loginWithProxyPdnFailure = importer(
  "Sagas/Users/loginWithProxyPdn/failure"
);

const logout = importer("Sagas/Users/logout/main");
const logoutSuccess = importer("Sagas/Users/logout/success");
const logoutFailure = importer("Sagas/Users/logout/failure");

const register = importer("Sagas/Users/register/main");
const registerSuccess = importer("Sagas/Users/register/success");
const registerFailure = importer("Sagas/Users/register/failure");

const getSession = importer("Sagas/Users/getSession/main");
const getSessionSuccess = importer("Sagas/Users/getSession/success");
const getSessionFailure = importer("Sagas/Users/getSession/failure");

const getSessionUser = importer("Sagas/Users/getSessionUser/main");
const getSessionUserSuccess = importer("Sagas/Users/getSessionUser/success");
const getSessionUserFailure = importer("Sagas/Users/getSessionUser/failure");

const getLoggedInUser = importer("Sagas/Users/getLoggedInUser/main");
const getLoggedInUserSuccess = importer("Sagas/Users/getLoggedInUser/success");
const getLoggedInUserFailure = importer("Sagas/Users/getLoggedInUser/failure");

const verifyEmail = importer("Sagas/Users/verifyEmail/main");
const verifyEmailSuccess = importer("Sagas/Users/verifyEmail/success");
const verifyEmailFailure = importer("Sagas/Users/verifyEmail/failure");

const changeDefaultCenter = importer("Sagas/Users/changeDefaultCenter/main");
const changeDefaultCenterSuccess = importer(
  "Sagas/Users/changeDefaultCenter/success"
);
const changeDefaultCenterFailure = importer(
  "Sagas/Users/changeDefaultCenter/failure"
);

const updateAccountSetting = importer("Sagas/Users/updateAccountSetting/main");
const updateAccountSettingSuccess = importer(
  "Sagas/Users/updateAccountSetting/success"
);
const updateAccountSettingFailure = importer(
  "Sagas/Users/updateAccountSetting/failure"
);

const mergeAccountSetting = importer("Sagas/Users/mergeAccountSetting/main");
const mergeAccountSettingSuccess = importer(
  "Sagas/Users/mergeAccountSetting/success"
);
const mergeAccountSettingFailure = importer(
  "Sagas/Users/mergeAccountSetting/failure"
);

const resendVerification = importer("Sagas/Users/resendVerification/main");
const resendVerificationSuccess = importer(
  "Sagas/Users/resendVerification/success"
);
const resendVerificationFailure = importer(
  "Sagas/Users/resendVerification/failure"
);

const resetPassword = importer("Sagas/Users/resetPassword/main");
const resetPasswordSuccess = importer("Sagas/Users/resetPassword/success");
const resetPasswordFailure = importer("Sagas/Users/resetPassword/failure");

const resetPassword2 = importer("Sagas/Users/resetPassword2/main");
const resetPassword2Success = importer("Sagas/Users/resetPassword2/success");
const resetPassword2Failure = importer("Sagas/Users/resetPassword2/failure");

const resetPassword3 = importer("Sagas/Users/resetPassword3/main");
const resetPassword3Success = importer("Sagas/Users/resetPassword3/success");
const resetPassword3Failure = importer("Sagas/Users/resetPassword3/failure");

const setupNewPassword = importer("Sagas/Users/setupNewPassword/main");
const setupNewPasswordSuccess = importer(
  "Sagas/Users/setupNewPassword/success"
);
const setupNewPasswordFailure = importer(
  "Sagas/Users/setupNewPassword/failure"
);

const sessionRefresh = importer("Sagas/Users/sessionRefresh/main");
const sessionRefreshSuccess = importer("Sagas/Users/sessionRefresh/success");
const sessionRefreshFailure = importer("Sagas/Users/sessionRefresh/failure");

const verifyOktaAccount = importer("Sagas/Users/verifyOktaAccount/main");
const verifyOktaAccountSuccess = importer(
  "Sagas/Users/verifyOktaAccount/success"
);
const verifyOktaAccountFailure = importer(
  "Sagas/Users/verifyOktaAccount/failure"
);

const changePassword = importer("Sagas/Users/changePassword/main");
const changePasswordSuccess = importer("Sagas/Users/changePassword/success");
const changePasswordFailure = importer("Sagas/Users/changePassword/failure");

const emailLogin = importer("Sagas/Users/emailLogin/main");
const emailLoginSuccess = importer("Sagas/Users/emailLogin/success");
const emailLoginFailure = importer("Sagas/Users/emailLogin/failure");

const socialLogin = importer("Sagas/Users/socialLogin/main");
const socialLoginSuccess = importer("Sagas/Users/socialLogin/success");
const socialLoginFailure = importer("Sagas/Users/socialLogin/failure");

const enrollMfa = importer("Sagas/Users/enrollMfa/main");
const enrollMfaSuccess = importer("Sagas/Users/enrollMfa/success");
const enrollMfaFailure = importer("Sagas/Users/enrollMfa/failure");

const resendEnrollMfaCode = importer("Sagas/Users/resendEnrollMfaCode/main");
const resendEnrollMfaCodeSuccess = importer(
  "Sagas/Users/resendEnrollMfaCode/success"
);
const resendEnrollMfaCodeFailure = importer(
  "Sagas/Users/resendEnrollMfaCode/failure"
);

const sendMfaCode = importer("Sagas/Users/sendMfaCode/main");
const sendMfaCodeSuccess = importer("Sagas/Users/sendMfaCode/success");
const sendMfaCodeFailure = importer("Sagas/Users/sendMfaCode/failure");

const verifyMfaCode = importer("Sagas/Users/verifyMfaCode/main");
const verifyMfaCodeSuccess = importer("Sagas/Users/verifyMfaCode/success");
const verifyMfaCodeFailure = importer("Sagas/Users/verifyMfaCode/failure");

const getEnrolledMfaList = importer("Sagas/Users/getEnrolledMfaList/main");
const getEnrolledMfaListSuccess = importer(
  "Sagas/Users/getEnrolledMfaList/success"
);
const getEnrolledMfaListFailure = importer(
  "Sagas/Users/getEnrolledMfaList/failure"
);

const authenticateMfaCode = importer("Sagas/Users/authenticateMfaCode/main");
const authenticateMfaCodeSuccess = importer(
  "Sagas/Users/authenticateMfaCode/success"
);
const authenticateMfaCodeFailure = importer(
  "Sagas/Users/authenticateMfaCode/failure"
);

export default {
  login,
  loginSuccess,
  loginFailure,

  loginAuth,
  loginAuthSuccess,
  loginAuthFailure,

  loginHeroku,
  loginHerokuSuccess,
  loginHerokuFailure,

  loginWithToken,
  loginWithTokenSuccess,
  loginWithTokenFailure,

  loginTokenExchange,
  loginTokenExchangeSuccess,
  loginTokenExchangeFailure,

  loginWithProxyPdn,
  loginWithProxyPdnSuccess,
  loginWithProxyPdnFailure,

  logout,
  logoutSuccess,
  logoutFailure,

  register,
  registerSuccess,
  registerFailure,

  getSession,
  getSessionSuccess,
  getSessionFailure,

  getSessionUser,
  getSessionUserSuccess,
  getSessionUserFailure,

  getLoggedInUser,
  getLoggedInUserSuccess,
  getLoggedInUserFailure,

  verifyEmail,
  verifyEmailSuccess,
  verifyEmailFailure,

  changeDefaultCenter,
  changeDefaultCenterSuccess,
  changeDefaultCenterFailure,

  updateAccountSetting,
  updateAccountSettingSuccess,
  updateAccountSettingFailure,

  mergeAccountSetting,
  mergeAccountSettingSuccess,
  mergeAccountSettingFailure,

  resendVerification,
  resendVerificationSuccess,
  resendVerificationFailure,

  resetPassword,
  resetPasswordSuccess,
  resetPasswordFailure,

  resetPassword2,
  resetPassword2Success,
  resetPassword2Failure,

  resetPassword3,
  resetPassword3Success,
  resetPassword3Failure,

  setupNewPassword,
  setupNewPasswordSuccess,
  setupNewPasswordFailure,

  sessionRefresh,
  sessionRefreshSuccess,
  sessionRefreshFailure,

  verifyOktaAccount,
  verifyOktaAccountSuccess,
  verifyOktaAccountFailure,

  changePassword,
  changePasswordSuccess,
  changePasswordFailure,

  emailLogin,
  emailLoginSuccess,
  emailLoginFailure,

  socialLogin,
  socialLoginSuccess,
  socialLoginFailure,

  enrollMfa,
  enrollMfaSuccess,
  enrollMfaFailure,

  resendEnrollMfaCode,
  resendEnrollMfaCodeSuccess,
  resendEnrollMfaCodeFailure,

  sendMfaCode,
  sendMfaCodeSuccess,
  sendMfaCodeFailure,

  verifyMfaCode,
  verifyMfaCodeSuccess,
  verifyMfaCodeFailure,

  getEnrolledMfaList,
  getEnrolledMfaListSuccess,
  getEnrolledMfaListFailure,

  authenticateMfaCode,
  authenticateMfaCodeSuccess,
  authenticateMfaCodeFailure,
};
